import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '../../../css';

function Expand(props) {
  const { height, width, iconColor } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={width} height={height}>
      <path
        fill={iconColor}
        d="M10,21V19H6.41L10.91,14.5L9.5,13.09L5,17.59V14H3V21H10M14.5,10.91L19,6.41V10H21V3H14V5H17.59L13.09,9.5L14.5,10.91Z"
      />
    </svg>
  );
}

Expand.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  iconColor: PropTypes.string
};

Expand.defaultProps = {
  height: undefined,
  width: 120,
  iconColor: colors.colorGrey02
};

export default Expand;
